import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Job } from 'src/@core/interfaces/job/job.model';
import { AppService } from 'src/@core/services/app.service';
import { JobTypeService } from 'src/@core/services/job/job-type.service';
import { JobService } from 'src/@core/services/job/job.service';
import moment from 'moment';
import { roles } from 'src/app/shared/helpers/roles-permissions';
@Component({
  selector: 'hour4u-admin-agreement-doc',
  templateUrl: './agreement-doc.component.html',
  styleUrls: ['./agreement-doc.component.scss']
})
export class AgreementDocComponent implements OnInit {
  profile = this.appService.getCurrentAccount();
  selectedJob: Job = new Job();
  isLoading: boolean = false;
  jobType: any = {};

  agreementDate: any = moment(new Date()).format('MM-DD-YYYY');
  enterpriseName: string = "";
  enterpriseAddress: string = "";
  companyName: string = this.profile.user.userMeta.name;
  companyAdrress: string = null;
  commencementDate: any = moment(new Date()).format('MM-DD-YYYY');
  flatAmount: any = 0;
  advanceAmount: any = 0;

  invoiceDate: any = "";
  contractorCompanyName: string = "";
  agencySignatureUploadedDate: any = moment(new Date()).format('MM-DD-YYYY');
  clientName: string = "";
  agencySignature: any = null;

  contractorName: string = this.profile.user.userMeta.name;
  enterpriseSignatureDate: any = moment(new Date()).format('MM-DD-YYYY');
  enterpriseSignature: any = null;

  @Input() jobId?: any = null;
  @Input() selectedQuote?: any = null;
  @Input() isViewOnly?: boolean = false;
  @Input() contractMetaData?: any = null;
  @Input() from?: any;

  @Output() filledSigedContractDetails = new EventEmitter();
  roles = roles;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appService: AppService,
    private jobService: JobService,
    private jobTypeService: JobTypeService,
    private cdRef: ChangeDetectorRef
  ) {
    document.addEventListener('DOMContentLoaded', () => {
      // Select all input elements with the class 'inputt-wrap'
      const inputs = document.querySelectorAll('.inputt-wrap') as NodeListOf<HTMLInputElement>;

      // Function to adjust the width of a given input element
      function adjustWidth(input: HTMLInputElement) {
        const valueLength = input.value.length;
        const newWidth = valueLength && (valueLength >= 20 && valueLength <= 40) ? (valueLength + 1) * 8 : 150;
        input.style.width = `${newWidth}px`;
      }

      // Add event listeners to each input element
      inputs.forEach(input => {
        input.addEventListener('input', () => adjustWidth(input));

        // Initialize the width based on the current value
        adjustWidth(input);
      });
    });
  }

  ngOnInit() {
    console.log(this.from)

    this.route.params.subscribe((data: any) => {
      const isEmpty = (obj) => {
        return Object.keys(obj).length === 0;
      };
      if (!isEmpty(data)) {
        this.selectedJob.id = data.id;
        if (this.jobId) {
          this.selectedJob.id = this.jobId;
          if (this.selectedQuote) {
            this.setPDFValues();
          }
        }
        this.loadData();
      } else {
        this.selectedJob = JSON.parse(localStorage.getItem("selectedPojectData"));
        this.jobType.name = this.selectedJob.type;
        this.enterpriseName = this.selectedJob.employerName;
        this.clientName = this.selectedJob.employerName;
        if (this.profile.entity.entityType === 'AGENCY') {
          this.getTotalAmount();
        }
        this.emitUpdatedPDFData();
      }
    });
  }

  setPDFValues() {
    if (this.selectedQuote.contractMetaData) {
      this.agreementDate = this.selectedQuote.contractMetaData.agreementDate || "";
      this.invoiceDate = this.selectedQuote.contractMetaData.invoiceDate || "";
      this.enterpriseName = this.selectedQuote.contractMetaData.enterpriseName || "";
      this.enterpriseAddress = this.selectedQuote.contractMetaData.enterpriseAddress || "";
      this.companyName = this.selectedQuote.contractMetaData.companyName || "";
      this.companyAdrress = this.selectedQuote.contractMetaData.companyAdrress || "";
      this.commencementDate = this.selectedQuote.contractMetaData.commencementDate || "";
      this.flatAmount = this.selectedQuote.contractMetaData.flatAmount || "";
      this.advanceAmount = this.selectedQuote.contractMetaData.advanceAmount || "";
      this.contractorCompanyName = this.selectedQuote.contractMetaData.contractorCompanyName || "";
      this.agencySignatureUploadedDate = this.selectedQuote.contractMetaData.agencySignatureUploadedDate || "";
      this.contractorName = this.selectedQuote.contractMetaData.contractorName || "";
      this.agencySignature = this.selectedQuote.contractMetaData.agencySignature || "";
      this.clientName = this.selectedQuote.contractMetaData.clientName || "";
      this.enterpriseSignatureDate = this.selectedQuote.contractMetaData.enterpriseSignatureDate || "";
      this.enterpriseSignature = this.selectedQuote.contractMetaData.enterpriseSignature || "";
    }
  }

  getFinalTotalAmount() {
    let amount = 0;
    if (this.selectedQuote && this.selectedQuote.jobRateCards && this.selectedQuote.jobRateCards.length) {
      this.selectedQuote.jobRateCards.forEach(element => {
        amount = amount + (element.totalAmount);
      });
    }
    return amount;
  }

  loadData() {
    this.isLoading = true;
    let params = {};
    if (this.profile && this.profile.entity && this.profile.entity.id) {
      if (this.profile.entity.entityType == 'AGENCY') {
        params = { 'entityId': this.profile.entity.id };
      }
    }
    if (this.selectedJob.id) {
      this.jobService.getJobDetailsById(this.selectedJob.id, params).subscribe((job: any) => {
        this.isLoading = false;
        this.selectedJob = job;
        // this.getTotalAmount();
        if (this.selectedJob && this.selectedJob.jobTypeId) {
          this.loadJobType();
        }
      })
    }
  }

  loadJobType() {
    this.jobTypeService.getById(this.selectedJob.jobTypeId).subscribe(type => {
      this.jobType = type;
    })
  }

  getTotalAmount() {
    let amount = 0;
    if (this.selectedJob && this.selectedJob.rateCards && this.selectedJob.rateCards.length) {
      this.selectedJob.rateCards.forEach(element => {
        amount = amount + (element.rate * element.quantity);
      });
    }
    this.flatAmount = amount * 1.18;
    return amount;
  }

  onInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const { name, value } = inputElement;
    if (name === 'agreementDate') {
      this.agreementDate = value;
    } else if (name === 'invoiceDate') {
      this.invoiceDate = value;
    } else if (name === 'enterpriseName') {
      this.enterpriseName = value;
    } else if (name === 'enterpriseAddress') {
      this.enterpriseAddress = value;
    } else if (name === 'companyName') {
      this.companyName = value;
    } else if (name === 'companyAdrress') {
      this.companyAdrress = value;
    } else if (name === 'commencementDate') {
      this.commencementDate = value;
    } else if (name === 'flatAmount') {
      this.flatAmount = value;
    } else if (name === 'advanceAmount') {
      this.advanceAmount = value;
    } else if (name === 'contractorCompanyName') {
      this.contractorCompanyName = value;
    } else if (name === 'agencySignatureUploadedDate') {
      this.agencySignatureUploadedDate = value;
    } else if (name === 'contractorName') {
      this.contractorName = value;
    } else if (name === 'clientName') {
      this.clientName = value;
    } else if (name === 'enterpriseSignatureDate') {
      this.enterpriseSignatureDate = value;
    }
    this.emitUpdatedPDFData();
  }

  emitUpdatedPDFData() {
    let contractMetaData = {
      agreementDate: this.agreementDate,
      companyName: this.companyName,
      companyAdrress: this.companyAdrress,
      enterpriseName: this.enterpriseName,
      invoiceDate: this.invoiceDate,
      enterpriseAddress: this.enterpriseAddress,
      commencementDate: this.commencementDate,
      flatAmount: this.flatAmount,
      advanceAmount: this.advanceAmount,
      contractorCompanyName: this.contractorCompanyName,
      agencySignatureUploadedDate: this.agencySignatureUploadedDate,
      contractorName: this.contractorName,
      agencySignature: this.agencySignature,
      clientName: this.clientName,
      enterpriseSignatureDate: this.enterpriseSignatureDate,
      enterpriseSignature: this.enterpriseSignature,
    }
    this.filledSigedContractDetails.emit(contractMetaData);
  }

  refresh(selectedSignatureImg) {
    const blobToBase64 = (blob: Blob): Promise<string> => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          if (reader.result) {
            resolve(reader.result.toString());
          } else {
            reject('Could not convert blob to base64');
          }
        };
        reader.onerror = () => {
          reject('Could not convert blob to base64');
        };
        reader.readAsDataURL(blob);
      });
    };

    blobToBase64(selectedSignatureImg)
      .then(base64 => {
        if (this.profile.entity.entityType === 'ENTERPRISE') {
          this.enterpriseSignature = base64;
        }
        if (this.profile.entity.entityType === 'AGENCY') {
          this.agencySignature = base64;
        }
        this.cdRef.detectChanges();
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
}
